import {
  Box,
  Button,
  Image,
  Link,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import dayjs from "dayjs";
import { FormattedMessage } from "react-intl";
import { CenteredContent } from "../CenteredContent";
import { Href } from "../Href";

export function GoogleReviewBand() {
  const linkToGoogleReviews =
    "https://www.google.com/search?sca_esv=552fb68e3d08662a&sxsrf=AE3TifNJ-aqgoqhuzexRwvIwzhSm_sug6g:1760514991624&q=valentin+expertises&si=AMgyJEuzsz2NflaaWzrzdpjxXXRaJ2hfdMsbe_mSWso6src8s4BVZA1h8sTDwBZWMN1OA1Y586n0K3YWNa9MtvGDR9J08hisFZMAjXon-wYVgWuJJQvNz4I%3D&uds=AOm0WdHmOFDPI7FIyNbJw6Zwd9kSBy6Dse2CEHV7SxVzTj3FZ4Tq7OagUIWoT75HfwMkTD__Tj-9UJMinQkTF_MMeneWsSWUaNrZjIBDRAhkRFqvYRLJtjg&sa=X&sqi=2&ved=2ahUKEwjjgcq13aWQAxWgLPsDHeRWDx8Q3PALegQIHhAE&biw=1920&bih=993&dpr=1";

  const reviewAverageNote =
    process.env.NEXT_PUBLIC_GOOGLE_REVIEW_AVERAGE_NOTE ?? 4.7;

  const countReviews =
    process.env.NEXT_PUBLIC_GOOGLE_REVIEW_COUNT_REVIEWS ?? 60;

  return (
    <Box
      bgImage={`url(${generateFrontPath({
        id: "@front.internal-assets",
        parameters: { filePath: "pattern-with-gradient.png" },
        includeBasePath: true,
      })})`}
      position="relative"
      bgSize="auto"
      bgPosition={{ base: "bottom", md: "center" }}>
      <Box
        background={`url(${generateFrontPath({
          id: "@front.internal-assets",
          parameters: { filePath: "google-logo.png" },
          includeBasePath: true,
        })})
        `}
        backgroundSize="260px"
        backgroundRepeat="no-repeat"
        backgroundPosition={{ base: "top center", md: "15%" }}
        padding="1.5rem .625rem"
        position="relative">
        <CenteredContent>
          <SimpleGrid
            templateColumns={{ base: "1fr", md: "22% 78%" }}
            gap={{ base: 0, md: "1.5rem" }}
            flexDir={{ base: "column", md: "row" }}>
            <Stack alignItems="center" mt={{ base: "2rem", md: 0 }}>
              <Text
                textAlign="center"
                variant="h1"
                fontSize="4rem"
                color="white"
                mt="-.75rem">
                {`${reviewAverageNote}/5`}
              </Text>

              <Link
                href={linkToGoogleReviews}
                isExternal={true}
                textDecoration="underline"
                variant="text-button"
                color="brandPrimary.200"
                rel="noopener noreferrer">
                <FormattedMessage
                  defaultMessage="sur {count} avis clients"
                  values={{ count: countReviews }}
                />
              </Link>

              <Box>
                <Image
                  src={generateFrontPath({
                    id: "@front.internal-assets",
                    parameters: { filePath: "google-ratings.svg" },
                    includeBasePath: true,
                  })}
                  alt="Logo"
                  maxW="136px"
                  maxH="24px"
                />
              </Box>
            </Stack>

            <Stack
              spacing={{ base: "2.5rem", md: "1rem" }}
              maxWidth="95%"
              justifyContent="center">
              <Text variant="h4" color="white" mt={{ base: "5rem", md: 0 }}>
                <FormattedMessage
                  defaultMessage="Avec plus de {nbYears} ans d'expérience dans le domaine, notre cabinet se positionne comme un partenaire de confiance pour vous conseiller et défendre vos intérêts face aux assureurs."
                  values={{
                    nbYears: dayjs().diff(dayjs("1990-01-01"), "year"),
                  }}
                />
              </Text>

              <Href
                href={generateFrontPath({
                  id: "@front.leCabinet",
                })}>
                <Button
                  size="lg"
                  colorScheme="gray"
                  variant="outline"
                  _hover={{ color: "brandPrimary.700", bg: "white" }}
                  color="white">
                  <FormattedMessage defaultMessage="Découvrir notre cabinet" />
                </Button>
              </Href>
            </Stack>
          </SimpleGrid>
        </CenteredContent>
      </Box>
    </Box>
  );
}
